import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export interface DeleteRfqFilePayload {
  rfq_id: number;
  file_id: number;
}

/**
 * Delete a file from an RFQ.
 */
export const deleteRfqFile = async (
  payload: DeleteRfqFilePayload
): Promise<void> => {
  try {
    await apiService.delete(`/rfqs/${payload.rfq_id}/files/${payload.file_id}`);
  } catch (error) {
    throw handleAxiosError(error);
  }
};
